import { uploadOndcReport } from "../../services/ondcReportUpload";
import { ondcReportUploadFailure, ondcReportUpload } from "../actions/ondcReportUpload";
import { createAllActionCreators } from "./actionCreatorUtil";

const ondcReportActionCreators = {
  ondcReportAction: {
    service: uploadOndcReport,
    action: ondcReportUpload,
    responseNotification: {
      status: true,
      only: true,
    },
    upload: {
      status: true,
      notificationMessage: "Upload Failed",
      errorAction: ondcReportUploadFailure,
      errorActionMessage: (err) => (err.error
        ? `${err.message}: ${JSON.stringify(err.error)}`
        : err.message || "Something went wrong"),
    },
  },
};
export const { ondcReportAction } = createAllActionCreators(
  ondcReportActionCreators,
);
